<template>
  <div id="thank-you-wrapper" class="fixed h-screen w-screen z-50">
    <div class="sections">
      <div class="section section--darkblue"></div>
    </div>

    <div class="sections-colored">
      <div class="section section--lightblue"></div>
      <div class="section section--greenish"></div>
      <div class="section section--purple"></div>
      <div class="section section--pink"></div>
    </div>

    <div class="section section-shapes">
      <div class="circle"></div>
      <div class="square-wrapper">
        <div class="square square--first"></div>
        <div class="square square--second">
        </div>
      </div>
    </div>

    <div class="text">
      <h1 class="title text-3xl sm:text-4xl md:text-4xxl xxl:text-5xl leading-tight tracking-tight font-extrabold">Täname!<br>WEBLINE</h1>
      <h3 class="subtitle text-base md:text-lg xl:text-xl font-light leading-relaxed tracking-wide">
        Meie meeskond sai Teie sõnumi kätte. Hakkame kohe sellega tööle ja võtame Teiega peatselt ühendust.
      </h3>
    </div>
  </div>
</template>

<script>
import {gsap} from 'gsap'

export default {
  name: "MessageSent",
  mounted() {
    var wrapper = '#thank-you-wrapper'
    var sec1 = '.sections-colored';
    var circle = '.circle';
    var squareWrapper = document.querySelector('.square-wrapper');
    var secShapes = '.section-shapes';
    var squareFirst = '.square--first';
    var squareSecond = '.square--second';
    var title = '.title';
    var subtitle = '.subtitle';
    var tl

    gsap.set(wrapper, {autoAlpha: 0})
    const _self = this
    function createAnim() {
      tl = gsap.timeline({
        repeat: 1,
        yoyo: true,
        repeatDelay: 0,
        defaults: {duration: 1}
      });
      tl.to(wrapper, {autoAlpha: 1})
      tl.to(sec1, {duration: 2, y: '-500vh'}, 0);
      tl.to(circle, {opacity: 1}, 0.5);
      tl.to(squareWrapper, {y: '-100vh'}, '<');
      tl.to(squareFirst, {opacity: 0});
      tl.to(secShapes, {y: '-45vh'}, "<+=0.5");
      tl.to(title, {duration: 2.3, opacity: 0.2, y: 0, ease: "power4"}, 1.5);
      tl.to(title, {duration: 2.3, opacity: 1, y: 0, ease: "power4", overwrite: 'auto'}, 2);

      tl.to(circle, {y: '-10vh', ease: "power4"}, 1.6);
      tl.to(squareSecond, 0.6, {duration: 0.6, y: '15vh'}, 1.6);
      tl.to(circle, {duration: 1.3, y: '100vh', ease: "power3"}, 2.5);
      tl.to(squareSecond, {duration: 1.3, y: '-100vh', ease: "power3"}, 2.5);

      tl.to(subtitle, {duration: 3, opacity: 1, y: 0, ease: "power4"}, 3)
      tl.eventCallback('onComplete', () => {
        _self.$emit('onComplete')
      })
    }

    createAnim();

    var timeout;
    window.addEventListener("orientationchange", function () {
      if (tl) tl.progress(0).kill();
      if (timeout) timeout.kill();

      timeout = gsap.delayedCall(function () {
        createAnim();
      }, 3);
    });
  }

}
</script>

<style scoped>
#thank-you-wrapper {
  height: 100vh;
  overflow: hidden;
}

.text {
  position: absolute;
  top: 50%;
  left: 20%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  color: white;
  z-index: 99999;
}

.title,
.subtitle {
  -webkit-transform: translateY(25%);
  transform: translateY(25%);
  opacity: 0;
}

.subtitle {
  max-width: 500px;
}

@media(min-width:1024px) {
  .subtitle {
    margin-left:170px;
  }
}

.section {
  width: 100%;
  height: 100vh;
}

.section--darkblue {
  background-color:#c3dafe;
}

.section--lightblue {
  background-color: #2c5282;
}

.section--greenish {
  background-color: #68d391;
}

.section--purple {
  background-color: #b794f4;
}

.section--pink {
  background-color: #fbb6ce;
}

.sections-colored {
  opacity: 0.5;
}

.section-shapes {
  position: absolute;
  z-index: 999;
  top: 0;
  bottom: 0;
}

.circle {
  position: relative;
  margin: 0 auto;
  width: 100vh;
  padding-bottom: 100vh;
  border-radius: 50%;
  background: rgba(127, 156, 245, 0.5);
  opacity: 0;
}

.square {
  width: 100vh;
  height: auto;
  margin: 0 auto;
  padding-bottom: 100vh;
  background: rgba(127, 156, 245, 0.5);
}

.square--second {
  background: rgba(127, 156, 245, 0.1);
}

</style>

